module.exports = __webpack_public_path__ + "img/types_hierarchy.7a5dd991.jpg";